module.exports = __webpack_public_path__ + "img/B10.02da160d.svg";